export default "__VITE_ASSET__DIQ_AzAB__"